import React from "react";

export const FormLabelAsterisk: React.FC = () => {
  return (
    <span aria-hidden="true" className="MuiFormLabel-asterisk">
      *
    </span>
  );
};
